import React from 'react';
import type { Coordinates, SavedCalendarPlace } from '../../types';
import AddressAutocomplete from '../map/AddressAutocomplete';
import '../map/AddressAutocomplete.css';
import { newSavedPlaceId } from '../../utils/executiveCalendarSettings';
import './TripPlacePicker.css';

type Props = {
  placeId: string;
  tripPlaces: SavedCalendarPlace[];
  onSelect: (placeId: string) => void;
  onAddPlace: (place: SavedCalendarPlace) => void;
};

const TripPlacePicker: React.FC<Props> = ({
  placeId,
  tripPlaces,
  onSelect,
  onAddPlace,
}) => {
  const selected = tripPlaces.find(p => p.id === placeId);

  const handleSearchSelect = (
    location: string,
    _address?: unknown,
    coordinates?: Coordinates,
    placeLabel?: string,
  ) => {
    const address = location.trim();
    if (!address) return;

    const existing = tripPlaces.find(
      p => p.address.trim().toLowerCase() === address.toLowerCase(),
    );
    if (existing) {
      onSelect(existing.id);
      return;
    }

    const place: SavedCalendarPlace = {
      id: newSavedPlaceId(),
      label: placeLabel?.trim() || address.split(',')[0]?.trim() || 'Location',
      address,
    };
    if (coordinates) {
      place.lat = coordinates.lat;
      place.lng = coordinates.lng;
    }
    onAddPlace(place);
    onSelect(place.id);
  };

  return (
    <div className="trip-place-picker">
      <label className="trip-place-picker-label">Location</label>

      <AddressAutocomplete
        className="trip-place-picker-search"
        searchMode="places"
        value={selected?.address || ''}
        placeholder="Search business or address…"
        onChange={handleSearchSelect}
      />

      {selected && (
        <p className="trip-place-picker-selected">
          Selected: <strong>{selected.label}</strong>
          <span className="trip-place-picker-selected-addr">{selected.address}</span>
        </p>
      )}
    </div>
  );
};

export default TripPlacePicker;
